import styled from 'styled-components';

export const Overlay = styled.div<{ $open: boolean }>`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.72);
  z-index: 4000;
  display: ${({ $open }) => ($open ? 'flex' : 'none')};
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(4px);
`;

export const Box = styled.div`
  background: #1e2429;
  border: 1px solid #3a2424;
  border-radius: 14px;
  padding: 24px 26px 20px;
  width: 420px;
  max-width: 92vw;
  box-shadow: 0 40px 100px rgba(0, 0, 0, 0.7);
  font-family: var(--body);
`;

export const Title = styled.div`
  font-family: var(--head);
  font-size: 19px;
  font-weight: 600;
  color: #f0e0e0;
  margin-bottom: 10px;
`;

export const Msg = styled.div`
  font-size: 13px;
  color: #c2b2b2;
  line-height: 1.55;
  margin-bottom: 20px;
`;

export const Actions = styled.div`
  display: flex;
  gap: 10px;
`;

export const CancelBtn = styled.button`
  flex: 1;
  border: none;
  border-radius: 8px;
  padding: 12px 0;
  font-weight: 700;
  font-size: 15px;
  font-family: var(--body);
  cursor: pointer;
  transition: background 0.15s;
  background: #ff7a10;
  color: #fff;

  &:hover {
    background: #ff8c2e;
  }
`;

export const OkBtn = styled.button`
  flex: 1;
  border-radius: 8px;
  padding: 12px 0;
  font-weight: 700;
  font-size: 14px;
  font-family: var(--body);
  cursor: pointer;
  transition: background 0.15s;
  background: rgba(160, 50, 50, 0.35);
  color: #d49090;
  border: 1px solid rgba(160, 50, 50, 0.4);

  &:hover {
    background: rgba(160, 50, 50, 0.5);
  }
`;
